import React, { useState } from 'react';
import PublicPageWrapper from '../../components/PublicPageWrapper';
import { Button } from '../../components/ui/button';
import { Input } from '../../components/ui/input';
import { Label } from '../../components/ui/label';
import { Textarea } from '../../components/ui/textarea';
import { MapPin, Phone, Mail, Clock, Send } from 'lucide-react';
import { toast } from 'sonner';

export default function ContactPage() {
  const [form, setForm] = useState({ name: '', email: '', phone: '', subject: '', message: '' });

  const handleSubmit = (e) => {
    e.preventDefault();
    toast.success('Message sent! We will get back to you soon.');
    setForm({ name: '', email: '', phone: '', subject: '', message: '' });
  };

  return (
    <PublicPageWrapper title="Contact Us" subtitle="We'd love to hear from you. Reach out to us anytime.">
      <div data-testid="contact-page">
        <div className="grid lg:grid-cols-3 gap-10">
          <div>
            <h2 className="text-lg font-bold text-[#1B2A4A] mb-5">Contact Information</h2>
            <div className="space-y-5">
              {[
                { icon: MapPin, label: 'Address', value: '160 Robert Mugabe Road\nEastlea, Harare, Zimbabwe' },
                { icon: Phone, label: 'Phone', value: '+263 772 410 971' },
                { icon: Mail, label: 'Email', value: 'info@tadam.co.zw\nadmissions@tadam.co.zw' },
                { icon: Clock, label: 'Office Hours', value: 'Mon-Fri: 07:30 - 16:00' },
              ].map(item => (
                <div key={item.label} className="flex gap-3">
                  <div className="w-9 h-9 rounded-lg bg-amber-50 flex items-center justify-center flex-shrink-0">
                    <item.icon className="w-4 h-4 text-[#E8A830]" />
                  </div>
                  <div>
                    <p className="font-bold text-sm text-[#1B2A4A]">{item.label}</p>
                    <p className="text-sm text-slate-500 whitespace-pre-line">{item.value}</p>
                  </div>
                </div>
              ))}
            </div>
            <div className="mt-8">
              <h2 className="text-lg font-bold text-[#1B2A4A] mb-4">Department Emails</h2>
              <div className="space-y-2.5">
                {[
                  { dept: 'School Administration', email: 'admin@tadam.co.zw' },
                  { dept: 'Accounts Department', email: 'accounts@tadam.co.zw' },
                  { dept: 'Pre-School', email: 'infants@tadam.co.zw' },
                  { dept: 'Primary School', email: 'primary@tadam.co.zw' },
                  { dept: 'Secondary School', email: 'secondary@tadam.co.zw' },
                  { dept: 'Teacher in Charge', email: 'rachelle@tadam.co.zw' },
                ].map(d => (
                  <div key={d.email} className="flex items-center gap-2.5">
                    <Mail className="w-3.5 h-3.5 text-[#E8A830] flex-shrink-0" />
                    <div className="min-w-0">
                      <p className="text-xs font-bold text-[#1B2A4A]">{d.dept}</p>
                      <a href={`mailto:${d.email}`} className="text-xs text-slate-500 hover:text-[#E8A830] transition-colors">{d.email}</a>
                    </div>
                  </div>
                ))}
              </div>
            </div>
          </div>
          <div className="lg:col-span-2">
            <div className="bg-white rounded-2xl border border-slate-100 p-6">
              <h2 className="text-lg font-bold text-[#1B2A4A] mb-5">Send a Message</h2>
              <form onSubmit={handleSubmit} className="space-y-4">
                <div className="grid sm:grid-cols-2 gap-4">
                  <div><Label>Full Name *</Label><Input required value={form.name} onChange={e => setForm({...form, name: e.target.value})} data-testid="contact-name" /></div>
                  <div><Label>Email *</Label><Input type="email" required value={form.email} onChange={e => setForm({...form, email: e.target.value})} data-testid="contact-email" /></div>
                </div>
                <div className="grid sm:grid-cols-2 gap-4">
                  <div><Label>Phone</Label><Input value={form.phone} onChange={e => setForm({...form, phone: e.target.value})} /></div>
                  <div><Label>Subject *</Label><Input required value={form.subject} onChange={e => setForm({...form, subject: e.target.value})} /></div>
                </div>
                <div><Label>Message *</Label><Textarea required rows={4} value={form.message} onChange={e => setForm({...form, message: e.target.value})} data-testid="contact-message" /></div>
                <Button type="submit" className="rounded-full bg-[#1B2A4A] hover:bg-[#283E6B] font-bold text-xs h-9 px-6" data-testid="contact-submit-btn"><Send className="w-3.5 h-3.5 mr-1" /> Send Message</Button>
              </form>
            </div>
          </div>
        </div>
      </div>
    </PublicPageWrapper>
  );
}
